<script setup lang="ts">
import { ref, onMounted } from "vue";

const showNotice = ref(false);

onMounted(() => {
    if (sessionStorage.getItem("reauth_notice") === "1") {
        showNotice.value = true;
        sessionStorage.removeItem("reauth_notice");

        setTimeout(() => {
            showNotice.value = false;
        }, 4000);
    }
});
</script>

<template>
    <div v-if="showNotice">
        Your session expired. Reconnecting...
    </div>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
